export default {
      id: "job-manager-usage",
      viewBox: "0 0 49 49",
      url: __webpack_public_path__ + "img/icons.svg#job-manager",
      toString: function () {
        return this.url;
      }
    }